import styled from 'styled-components';
import { Icon, Typography } from '../../../stories/atoms';

import { ColumnFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';

export const StyledNoteTypography = styled(Typography)`
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.inherit : color.backgroundWarning};
  border-radius: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme: { color, palette } }) => (palette.mode === 'dark' ? color.warning : color.warningDark)};
  border: ${({ theme: { color, palette } }) => palette.mode === 'dark' && `1px solid ${color.warning}`};
`;

export const StyledColumnFlexContainer = styled(ColumnFlexContainer)<{ isMobileView: boolean }>`
  min-width: ${({ theme: { spacing }, isMobileView }) => (isMobileView ? spacing(100) : spacing(125))};
  max-width: ${({ theme: { spacing } }) => spacing(200)};
`;

export const StyledTitleTypography = styled(Typography)`
  ${({ theme: { breakpoints } }) => breakpoints.down('tabletPortrait')} {
    line-height: 1;
  }
`;

export const StyledIcon = styled(Icon)`
  width: ${({ theme: { spacing } }) => spacing(6)};
  height: ${({ theme: { spacing } }) => spacing(6)};
`;
